import { createActions } from "redux-actions";

const actions = createActions({
    UPDATE_CLIENT: (data) => ({data}),
    ADD_DOCUMENT: (data) => ({data}),
    DELETE_DOCUMENT: (data) =>({data}),
    EDIT_DOCUMENT: (data) => ({data}),
    REFRESH_DATA: () => ({})
})

export const updateClient = actions.updateClient;
export const addDocument = actions.addDocument;
export const editDocument = actions.editDocument;
export const deleteDocument = actions.deleteDocument;
export const refreshData = actions.refreshData;